<template>
  <div class="tw-space-y-2">
    <slot />
  </div>
</template>
